<div>
  <header nx-header>
    <div class="container-boxed">
      <nx-header-brand class="left-column--wrapper">
        <nx-link>
          <a [routerLink]="linkHeader">
            <figure nxFigure>
              <img
                class="left-column--logo"
                [src]="headerType + '.logo' | translate"
                [alt]="headerType + '.logoAlt' | translate"
                role="none"
              />
            </figure>
          </a>
        </nx-link>
      </nx-header-brand>
      <nx-header-brand class="right-column--wrapper">
        <span class="right-column--text">{{ headerType + '.title' | translate }}</span>
        <div *ngIf="headerType + '.subtitle' | translate">
          <span class="right-column--subtitle">{{ headerType + '.subtitle' | translate }}</span>
        </div>
      </nx-header-brand>
    </div>
  </header>
</div>
